import styled, { css } from 'styled-components';
import { FONT_WEIGHT, FONT_SIZE } from '@app/styles/themes/constants';
import { ThemeType } from '@app/interfaces/interfaces';
import { themeObject } from '@app/styles/themes/themeVariables';

type Color = 'main' | 'light' | 'superLight' | 'secondary' | 'dark' | 'subtext';
type Size = 'xxs' | 'xs' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl' | 'xxxxl';
type Weight = 'thin' | 'extraLight' | 'light' | 'regular' | 'medium' | 'semibold' | 'bold' | 'extraBold' | 'black';
type TextAlign = 'left' | 'right' | 'center';
type TextOverflow = 'clip' | 'ellipsis' | 'inherit' | 'revert' | 'rever-layer' | 'unset';

const textMapper = {
  main: 'textMain',
  light: 'textLight',
  superLight: 'textSuperLight',
  secondary: 'textSecondary',
  dark: 'textDark',
  subtext: 'textSubtext',
} as { [key: string]: string };

const textOverflowMapper = {
  ellipsis: css`
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  `,
  clip: css`
    text-overflow: clip;
  `,
  inherit: css`
    text-overflow: inherit;
  `,
  revert: css`
    text-overflow: revert;
  `,
  'rever-layer': css`
    text-overflow: revert-layer;
  `,
  unset: css`
    text-overflow: unset;
  `,
};

export interface IStyledBaseTextProps {
  color?: Color;
  className?: string;
  size?: Size;
  weight?: Weight;
  theme?: ThemeType;
  textAlign?: TextAlign;
  textOverflow?: TextOverflow;
}

export const styledBaseTextPropsKeys = ['color', 'className', 'size', 'weight', 'theme', 'textAlign', 'textOverflow'];

export const StyledBaseText = styled('span').withConfig({
  shouldForwardProp: (prop) => !styledBaseTextPropsKeys.includes(prop),
})<IStyledBaseTextProps>`
  ${(props) => {
    const targetTheme = themeObject[props.theme as keyof typeof themeObject];
    const targetKey = textMapper[props.color as keyof typeof textMapper];
    const targetColor = targetTheme[targetKey as keyof typeof targetTheme] as string;
    const textOverflow = props.textOverflow ? props.textOverflow : 'clip';

    return css`
      font-weight: ${FONT_WEIGHT[props.weight as Weight]};
      line-height: 1.5625rem;
      font-size: ${FONT_SIZE[props.size as Size]};
      color: ${targetColor};
      text-align: ${props.textAlign};
      ${textOverflowMapper[textOverflow]};
    `;
  }}
`;
